import {isRejectedWithValue} from '@reduxjs/toolkit';
import {NotificationManager} from '../components/common/react-notifications';

const checkDriverAppToPortalsApiNetworkError = action => action.payload.status === 'FETCH_ERROR';
// data.message if portals does res.send({message: 'blah})
// just data if portals does res.send(err.message)
const checkPortalsToOtherServerNetworkError = action => {
  const message = action.payload.data?.message || action.payload.data;
  return message?.includes('ECONNREFUSED');
};

/**
 * Checks for values in the action seen if portals errors cetain ways during a query
 */
const checkIsQueryNetworkError = action => action.type === 'api/executeQuery/rejected' && (
  checkDriverAppToPortalsApiNetworkError(action)
  || checkPortalsToOtherServerNetworkError(action)
);

/**
 * Checks for values in the action seen if portals errors cetain ways during a mutation
 */
const checkIsMutationNetworkError = action => action.payload.status === 'FETCH_ERROR' && action.type === 'api/executeMutation/rejected';

/**
 * Parses error from api call and sends a notification unless we decide not to
 */
const handleError = api => next => action => {
  if (action.payload?.skipMiddleware || !isRejectedWithValue(action)) return next(action);

  // network-related errors during GET cause an alert to be shown
  try {
    if (checkIsQueryNetworkError(action)) {
      return next({...action, payload: {alertId: 'network-error'}});
    }
  } catch (err) {
    // in case the action isn't formatted as epected, should be fine though so just log and move on
    console.warn(err); // eslint-disable-line no-console
  }

  NotificationManager.clearNotifications();

  // Other methods will show a notification on connection errors
  if (checkIsMutationNetworkError(action)) {
    NotificationManager.error(
      "We're sorry, we seem to be having trouble connecting to our servers and cannot process this action at this time. Please try again later, or contact support for assistance.",
      'Network Error',
    );
  } else {
    // Other kinds of errors handled normally
    NotificationManager.persistentError(
      action.payload.message // manual error from api.js
        || action.payload.error // manual error from api.js
        || action.payload.data?.message // res.status(500).send({message: 'blahblah'})
        || action.payload,
      action.payload.title || 'Error',
    );
  }
  return next(action);
};

export default handleError;
